export const DRAWER_PADDING_SCALE = 7;

export enum DIRECTION {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum DRAWER_SIZE {
  X_SMALL = 240,
  TINY = 350,
  SMALL = 600,
  MEDIUM = 720,
  LARGE = 1120,
  FULL_SCREEN = 'FULL_SCREEN',
}
